/**
 * 화면의 "지금" 상태 — **끊긴 화면은 오프라인 하나만 말한다**(2026-10-21).
 *
 * 정비 모드·오류는 기기가 하트비트에 실어 보낸 마지막 값이라, 기기가 끊긴 뒤에도 서버에 그대로 남는다. 그래서 꺼진
 * 화면이 "정비 모드"·"Failed to fetch"(망이 끊기며 기기가 적은 오류)를 달고 화면 현황에 섰다 — 지금 그런지 아무도
 * 모르는 말이고, 끊긴 화면에서 볼 것은 "오프라인" 하나다. 다시 붙으면 기기가 지금 값을 보고하므로 그때 다시 보인다.
 *
 * 서버의 요약(`/displays/summary` 의 `erroring`·`maintenance`)도 켜진 화면만 센다. 끊긴 화면의 마지막 오류는 콘솔 어디에도
 * 내지 않는다(화면 상세 기본 정보의 "마지막 오류"·"끊기기 전 오류" 줄도 2026-10-21 뺐다 — 켜진 화면의 오류 글은 머리의
 * "오류 보고" 배지에 마우스를 올리면 보인다).
 */
export interface LiveStatus {
  /** 지금 정비 모드인가 — 끊긴 화면은 모른다(false). */
  maintenance: boolean;
  /** 지금 보고된 오류 — 끊긴 화면은 null. */
  error: string | null;
}

export function liveStatus(
  online: boolean,
  maintenance: boolean | null | undefined,
  lastError: string | null | undefined,
): LiveStatus {
  if (!online) return { maintenance: false, error: null };
  return { maintenance: maintenance === true, error: lastError ? lastError : null };
}

/** 화면 조회 한 줄(`Display`)에서 — 콘솔 화면들이 쓰는 꼴. */
export function displayLive(display: {
  online: boolean;
  status: { maintenance?: boolean | null; last_error?: string | null };
}): LiveStatus {
  return liveStatus(display.online, display.status.maintenance, display.status.last_error);
}
